import { render, staticRenderFns } from "./RequestBrochureModal.vue?vue&type=template&id=af35baea&"
import script from "./RequestBrochureModal.vue?vue&type=script&lang=js&"
export * from "./RequestBrochureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports